import theme from '../base'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

const chip = {
  MuiChip: {
    defaultProps: {
      deleteIcon: <X />,
    },
    styleOverrides: {
      root: {
        position: 'relative',
        height: theme.spacing(3),
        margin: theme.spacing(0, 1, 1, 0),
        backgroundColor: theme.palette.neutral.lightest,
        zIndex: 1,

        // Specificity issue
        '& .MuiChip-avatar': {
          width: theme.spacing(2),
          height: theme.spacing(2),
        },

        '&.success': {
          cursor: 'pointer',
          backgroundColor: theme.palette.success.dark,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.neutral.dark,
            justifyItems:'left !important'
          },
        },

        '&.primary': {
          cursor: 'pointer',
          backgroundColor: theme.palette.primary.lightest,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.primary.dark,
            justifyItems:'left !important'
          },
          '&.MuiChip-sizeSmall .MuiChip-icon': {
            color: theme.palette.primary.main,
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
          '&.MuiChip-sizeMedium .MuiChip-icon': {
            color: theme.palette.primary.main,
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
          '&.has-cursorPointer': {
            cursor: 'pointer',
          },
        },

        '&.orange': {
          cursor: 'pointer',
          backgroundColor: theme.palette.orange.light,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.orange.darkest,
            justifyItems:'left !important'
          },
          '&.MuiChip-sizeSmall .MuiChip-icon': {
            color: theme.palette.orange.darkest,
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
          '&.MuiChip-sizeMedium .MuiChip-icon': {
            color: theme.palette.orange.darkest,
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
          '&.has-cursorPointer': {
            cursor: 'pointer',
          },
        },

        '&.green': {
          cursor: 'pointer',
          backgroundColor: theme.palette.green.light,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.green.darkest,
            justifyItems:'left !important'
          },
          '&.MuiChip-sizeSmall .MuiChip-icon': {
            color: theme.palette.green.darkest,
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
          '&.MuiChip-sizeMedium .MuiChip-icon': {
            color: theme.palette.green.darkest,
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
          '&.has-cursorPointer': {
            cursor: 'pointer',
          },
        },

        '&.purple': {
          cursor: 'pointer',
          backgroundColor: theme.palette.purple.lighter,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.purple.dark,
            justifyItems:'left !important'
          },
        },

        '&.turquoise': {
          cursor: 'pointer',
          backgroundColor: theme.palette.turquoise.lighter,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.turquoise.darkest,
            justifyItems:'left !important'
          },
        },

        '&.info': {
          backgroundColor: theme.palette.info.light,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.turquoise.darkest,
            justifyItems:'left !important'
          },
        },

        '&.red': {
          backgroundColor: theme.palette.error.light,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.error.dark,
            justifyItems:'left !important'
          },
        },

        '&.yellow': {
          cursor: 'pointer',
          backgroundColor: theme.palette.yellow.lighter,

          '& .MuiChip-label, & .MuiChip-avatar, & .MuiChip-deleteIcon': {
            color: theme.palette.yellow.darkest,
            justifyItems:'left !important'
          },

          '&.MuiChip-sizeSmall .MuiChip-icon': {
            color: theme.palette.yellow.darkest,
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
        },

        '&.subchip': {
          marginLeft: theme.spacing(-3),
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          zIndex: 0,
          '& .MuiChip-label': {
            paddingLeft: theme.spacing(4),
          },
          '&.primary': {
            backgroundColor: theme.palette.error.light,
          },
          '&.turquoise': {
            backgroundColor: theme.palette.info.light,
          },
          '&.green': {
            backgroundColor: theme.palette.green.lighter,
          },
        },

        // fix: when the chip has ellipses the icon appeared small, with flexShrink we maintain the correct size of the chip
        '&.statusCode .MuiChip-icon': {
          flexShrink: 0,
        },
      },
      label: {
        ...theme.typography.body2,
        color: theme.palette.neutral.main,
        paddingLeft: theme.spacing(14 / 8),
        paddingRight: theme.spacing(14 / 8),
        height: theme.spacing(2),
        lineHeight: theme.spacing(2),
        '& span': {
          color: theme.palette.neutral.dark,
        },
      },
      labelSmall: {
        paddingLeft: 10,
        paddingRight: 10,
      },
      deleteIcon: {
        marginRight: theme.spacing(1),
        width: theme.spacing(2),
        height: theme.spacing(2),
        color: theme.palette.neutral.main,
        '&:hover': {
          '&.MuiChip-deleteIconSmall, &.MuiChip-deleteIconMedium': {
            color: theme.palette.primary.main,
          },
        },
      },
      sizeSmall: {
        height: 20,
      },
    },
  },
}

export default chip
